import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Typography, Button, CircularProgress } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import ModuleCard from './ModuleCard'
import ScopeSelectionModal from '../../ProjectList/ScopeSelectionModal'

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  padding: 16
}

const ModulesSection = (props) => {
  const { projectId, project, url } = props
  const [modules, setModules] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [scopeModalOpen, setScopeModalOpen] = React.useState(false)

  const fetchModules = React.useCallback(() => {
    setLoading(true)
    axios.get(`${url}/api/bid-estimation/projects/${projectId}/modules`).then(res => {
      setModules(res.data)
      setLoading(false)
    }).catch(err => {
      console.error('Failed to fetch modules:', err)
      setLoading(false)
    })
  }, [url, projectId])

  React.useEffect(() => {
    fetchModules()
  }, [fetchModules])

  const handleStatusChange = (moduleId, newStatus) => {
    setModules(prev => prev.map(m => m._id === moduleId ? { ...m, status: newStatus } : m))
  }

  const handleSkipToggle = (moduleId, skipped) => {
    axios.put(`${url}/api/bid-estimation/modules/${moduleId}`, { skipped }).then(res => {
      setModules(prev => prev.map(m => m._id === moduleId ? res.data : m))
    }).catch(err => console.error('Skip toggle failed:', err))
  }

  const handleDelete = (moduleId) => {
    if (!window.confirm('Delete this module and all its tasks?')) return
    axios.delete(`${url}/api/bid-estimation/modules/${moduleId}`).then(() => {
      setModules(prev => prev.filter(m => m._id !== moduleId))
    }).catch(err => console.error('Delete failed:', err))
  }

  const handleScopeComplete = () => {
    setScopeModalOpen(false)
    fetchModules()
  }

  // For "Add Scope", filter out already-generated scopes
  const existingScopes = modules.map(m => m.scope)
  const addScopeProject = project ? {
    ...project,
    _id: projectId,
    templateSuggestedScopes: [] // no pre-checks when adding
  } : null

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>Modules</Typography>
        {modules.length > 0 && (
          <Button
            size="small"
            startIcon={<AddIcon />}
            onClick={() => setScopeModalOpen(true)}
            style={{ textTransform: 'none', fontSize: 12 }}
          >
            Add Scope
          </Button>
        )}
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
          <CircularProgress size={20} />
        </div>
      ) : modules.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 16 }}>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
            No scopes selected yet.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setScopeModalOpen(true)}
            style={{ textTransform: 'none' }}
          >
            Select Scopes
          </Button>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {modules.map(mod => (
            <ModuleCard
              key={mod._id}
              module={mod}
              onStatusChange={handleStatusChange}
              onSkipToggle={handleSkipToggle}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}

      <ScopeSelectionModal
        open={scopeModalOpen}
        project={addScopeProject}
        excludeScopes={existingScopes}
        onComplete={handleScopeComplete}
        onSkip={() => setScopeModalOpen(false)}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user
})

export default connect(mapStateToProps)(ModulesSection)
